<template>
  <div class="my-3">
    <div class="px-4 px-md-0">
      <v-img class="mx-auto mt-4" src="../assets/jpg/createAccountTitle.jpg" max-width="500"></v-img>
      <p class="text-center mb-4" style="color:#2B2B2B;">
        Liquitousアカウントは、これからLiqlidをご利用になる際に必要なものです。<br>以下の必要事項を入力して、アカウントを作成してください。
      </p>
    </div>
    <div class="pa-2 mx-auto main_box">
      <v-stepper v-model="currentStep" alt-labels height="auto">
        <v-stepper-header>
          <v-stepper-step step="1" :complete="currentStep>1">
            <span class="nowrap">必要事項の入力</span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="2" :complete="checkbox">
            <span class="nowrap">規約のご確認</span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3" :complete="currentStep>3">
            <span class="nowrap">入力内容のご確認</span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4">
            <span class="nowrap">アカウント作成完了</span>
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content class="v_stepper_content" step="1">
            <!-- this.errorMessageをいい感じに表示 -->
            <v-alert dense outlined v-if="errorMessage" type="error" class="mb-4" :value="true">
              {{ errorMessage }}
            </v-alert>
            <div
              class="mb-12"
            >
            <v-form v-model="valid">
              <v-col class="" cols="">
                <p class="mb-0">ハンドルネーム<span style="font-size: 0.7rem">（{{handleNameLength}}文字以内）</span></p>
                <v-col
                  class="name"
                >
                  <v-text-field
                    v-model="handlename"
                    :rules="nameRules"
                    :counter="handleNameLength"
                    placeholder="Liqlid上で表示したい名前を入力"
                    required
                    width="50"
                  ></v-text-field>
                </v-col>
                <p class="mb-0 mail-font">メールアドレス</p>
                <v-col
                  class="mail"
                >
                  <v-text-field
                    class="text-input-black ma-0"
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    placeholder="メールアドレスを入力"
                  ></v-text-field>
                </v-col>
                <p class="password-font">パスワード</p>
                <v-col
                  class="password"
                >
                  <v-text-field
                    class="text-input-black ma-0"
                    v-model="password"
                    :rules="[rules.required, rules.min]"
                    type="password"
                    name="input-10-1"
                    placeholder="パスワードを入力"
                    counter
                  ></v-text-field>
                  <div class="text-right rule">英数字8文字以上・大文字、小文字、数字必須</div>
                </v-col>
              </v-col>
            </v-form>
            </div>
            <div class="nav-button-wrapper">
              <router-link :to="pathBeforeSignup" style="text-decoration: none;">
                <v-btn
                  text
                >
                  <span style="color:#008CFF">＜</span> &nbsp; &nbsp;アカウント作成をやめる
                </v-btn>
              </router-link>

              <v-btn
                text
                :disabled="!handlename||!email||!password||!valid"
                @click="currentStep = (!checkbox ? 2 : 3)"
              >
                次へ&nbsp; &nbsp;<span style="color:#008CFF">＞</span>
              </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content class="v_stepper_content" step="2">
            <div
              class="mb-12"
            >
              <h3 class="text-center my-2" style="color: #BA0009">アカウントを作成する前に、以下の注意事項を必ずお読みください</h3>
              <div class="mx-auto pa-4 text-center" style="background-color:#F5F5F5;" rounded>
                <p>
                  <a href="https://drive.google.com/file/d/13yqWr0tXj2eb8898OBl_EbukMIASPZuK/view?usp=sharing">利用規約</a>
                </p>
                <p>
                  <a href="https://drive.google.com/file/d/1fSPDIhzqH4BPfpUUCPvTSGy8_d227hCP/view">プライバシーポリシー</a>
                </p>
                <p>
                  上記の２つをダウンロードして閲覧する場合は<a href="https://drive.google.com/file/d/1sOVrGMspt3bUgiglo8ygGhPhaiPo_cuz/view?usp=share_link">こちら（PDF）</a>
                </p>
              </div>
              <div class="d-flex justify-center">
                <v-checkbox
                  v-model="checkbox"
                  label="私は上記の規約に同意し、アカウントを作成します"
                  color="#008CFF"
                  class="mx-auto"
                ></v-checkbox>                
              </div>

            </div>
            <div class="nav-button-wrapper">
              <v-btn
                text
                @click="currentStep = 1"
              >
                <span style="color:#008CFF">＜</span> &nbsp; &nbsp;前へ
              </v-btn>

              <v-btn
                :disabled="!checkbox"
                text
                @click="currentStep = 3"
              >
                次へ&nbsp; &nbsp;<span style="color:#008CFF">＞</span>
              </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content class="v_stepper_content" step="3">
            <h3 class="text-center my-4" style="color: #BA0009">以下の内容でアカウントを作成します。 入力内容の確認とパスワードの再入力した上で、「アカウントを作成」ボタンを押してください</h3>
            <v-card class="mx-auto rounded-lg confirm_card" color="#F5F5F5" height="auto" flat>
              <v-row class="px-2 px-sm-0">
                <v-col sm="4" cols="12" class="text-sm-right"><p class="mb-0 name-font">ハンドルネーム :</p></v-col>
                <v-col sm="8" cols="11" class="ml-4 ml-sm-0"><p class="mb-0" v-text="handlename"></p></v-col>
              </v-row>
            </v-card>
            <v-card class="mx-auto my-6 rounded-lg confirm_card" color="#F5F5F5" height="auto" flat>
              <v-row class="px-2 px-sm-0">
                <v-col sm="4" cols="12" class="text-sm-right"><p class="mb-0 name-font">メールアドレス :</p></v-col>
                <v-col sm="8" cols="11" class="ml-4 ml-sm-0"><p class="mb-0" v-text="email"></p></v-col>
              </v-row>
            </v-card>
            <v-card class="mx-auto rounded-lg confirm_card" color="#F5F5F5" height="auto" flat>
              <v-row class="px-2 px-sm-0">
                <v-col sm="4" cols="12" class="text-sm-right"><p class="mb-0 name-font">パスワード :</p></v-col>
                <v-col sm="8" cols="11" class="ml-4 ml-sm-0"><p class="mb-0">（セキュリティのため非表示）</p></v-col>
              </v-row>
            </v-card>
            <div class="nav-button-wrapper">
              <v-btn
                text
                @click="currentStep=1,loading=false"
              >
                <span style="color:#008CFF">＜</span> &nbsp; &nbsp;修正する
              </v-btn>
              <v-btn
                rounded
                color="#008CFF"
                dark
                v-if="!loading"
                @click="submit"
              >
                アカウントを作成
              </v-btn>
              <v-btn
                rounded
                color="#008CFF"
                dark
                v-else
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content class="v_stepper_content" step="4">
            <div class="text-center mx-auto">
              <h1 class="text-center">アカウント作成が完了しました</h1>
              <p class="mb-0">確認メールを、入力したメールアドレス宛に送信しました</p>
              <v-icon color="#54E363" size="100px" class="my-4">mdi-checkbox-marked-circle</v-icon>
              <p style="color:#BA0009">初回のログインは、メール内の専用URLをクリックしてログインしてください 数分経っても受信されない場合は、迷惑メールフォルダも確認してください </p>
              <p>（受信が確認できたら、このページを閉じても問題ありません）</p>              
            </div>

            <div class="nav-button-wrapper">
              <router-link :to="pathBeforeSignup" class="mx-auto" style="text-decoration: none;">
                <v-btn
                  text
                >
                  ホーム画面へ&nbsp; &nbsp;<span style="color:#008CFF">＞</span>
                </v-btn>
              </router-link>
            </div>
          </v-stepper-content>
      </v-stepper-items>
      </v-stepper>        
    </div>
    <v-dialog
      v-if="authConfig.line || authConfig.slp"
      v-model="authMethodModal"
      max-width="350"
    >
      <v-card>
        <v-card-title class="">
          <!-- officerShown -->
          <span v-if="officerShown">職員番号と</span>
          <span v-if="authConfig.line">LINEと</span>
          <span v-if="authConfig.slp">SLPと</span>
          <span>メールの</span>どちらで登録しますか？
        </v-card-title>
        <v-card-text class="px-4 d-flex flex-column text-center justify-center">
          <v-btn
            v-if="officerShown"
            class="white--text my-2 w-auto mx-auto rounded-pill hajimeru__text"
            color="#008CFF"
            width="70%"
            @click="redirectToOfficerLogin"
          >
            職員番号で始める
          </v-btn>
          
          <line-button v-if="authConfig.line" class="mb-2">LINEで始める</line-button>
          <slp-button v-if="authConfig.slp" class="mb-2">SLPで始める</slp-button>
          <v-btn
            class="white--text w-auto mx-auto rounded-pill hajimeru__text"
            color="#008CFF"
            width="70%"
            @click="authMethodModal=false"
          >
            メールで始める
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lineButton from '../components/auth/parts/lineButton.vue'
import slpButton from '../components/auth/parts/slpButton.vue'
export default {
  components: { lineButton, slpButton },
  data () {
    return {
      authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
      authMethodModal: true,
      officerShown: false,
      currentStep: 1,
      valid: false,
      handlename: '',
      email: '',
      password: '',
      passwordConfirmation: '',
      checkbox: false,
      errorMessage: '',
      handleNameLength: Number(process.env.VUE_APP_VALUE_NAME_LENGTH || '20'),
      nameRules: [
        v => !!v || '名前を入力してください',
        v => v.length <= this.handleNameLength || `${this.handleNameLength}文字以下で入力してください`,
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'このE-mailは有効ではありません',
      ],
      rules: {
        required: value => !!value || '入力内容に誤りがあります',
        min: v => v.length >= 8 || '8文字以上で入力して下さい',
        emailMatch: () => (`The email and password you entered don't match`),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'メールアドレスの形式が違います'
        },
      },
      loading: false,
      pathBeforeSignup: "",
    }
  },
  mounted() {
    if (this.isAuthed) {
      window.location.href = '/'
    }

    if (localStorage.getItem('enableOfficerButton') === 'true' && this.authConfig.officer) {
      this.officerShown = true
    }
    
    const pathBeforeSignup = localStorage.getItem('pathBeforeSignup')
    if (pathBeforeSignup) {
      this.pathBeforeSignup = pathBeforeSignup
    }
  },
  computed: {
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
  },
  methods: {
    // asynmcでかく
    submit: async function() {
      this.errorMessage = ''
      this.loading = true
      const res = await this.$store.dispatch('auth/signUpEmailAndPassword', {
        email: this.email,
        password: this.password,
        name: this.handlename,
      })
      if (res.success) {
        this.currentStep = 4
      } else {
        this.loading = false
        console.error(res.error)
        if (res.error.code === 'auth/email-already-in-use') {
          this.errorMessage = 'このメールアドレスは既に登録されています'
        } else if (res.error.code === 'auth/invalid-email') {
          this.errorMessage = 'メールアドレスの形式が違います'
        } else if (res.error.code === 'auth/weak-password') {
          this.errorMessage = 'パスワードは8文字以上で入力して下さい'
        } else if (res.error.code === 'auth/operation-not-allowed') {
          // TODO: 以下3つはsentryに送る
          this.errorMessage = 'メールアドレスの登録が許可されていません'
        } else if (res.error.code === 'auth/too-many-requests') {
          this.errorMessage = 'アカウント作成のリクエストが多すぎます。しばらくしてから再度お試しください'
        } else {
          this.errorMessage = 'エラーが発生しました。しばらくしてから再度お試しください'
        }
        this.currentStep = 1;
      }
    },
    redirectToOfficerLogin() {
      this.$router.push('/officers-login')
    },
  }
}
</script>

<style scoped>
.name-font{
  color:#707070;
}
.nowrap {
  white-space: nowrap;
}

.nav-button-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.hajimeru__text {
    font-size: 1rem;
    height: 50%;
    font-weight: normal;
    color: #fff;
    margin: 0 40px 0 30px;
}
/*====================
PCを基本設計にする
 - 1280px〜：大型PC
 - 960px〜1279px：小型PC
 - 600px〜959px：タブレット
 - 480px〜599px：スマートフォン横
 - 〜479px：スマートフォン縦
====================*/

/* 1280px〜：大型PC
------------------------------ */
@media screen and (min-width: 1280px) {
  .main_box {
    width: 80%;
  }
  .confirm_card {
    width: 70%;
  }
}
/* 960px〜1279px：小型PC
------------------------------ */
@media screen and (min-width: 960px) and (max-width: 1279px) {
  .main_box {
    width: 80%;
  }
  .confirm_card {
    width: 70%;
  }
}
/* 600px〜959px：タブレット
------------------------------ */
@media screen and (min-width: 600px) and (max-width: 959px) {
  .main_box {
    width: 90%;
  }
  .confirm_card {
    width: 90%;
  }
}
/* 480px〜599px：SP横
------------------------------ */
@media screen and (min-width: 480px) and (max-width: 599px) {
  .main_box {
    width: 95%;
  }
  .confirm_card {
    width: 90%;
  }
}
/* 〜479px：スマートフォン縦
------------------------------ */
@media screen and (max-width: 479px) {
  .main_box {
    width: 100%;
  }
  .v_stepper_content {
    padding: 10px;
  }
  .confirm_card {
    width: 90%;
  }
}
</style>